module.exports = __webpack_public_path__ + "static/github-file-selection-dec7c31a4e3c78a542d970d1249f5c03.png";